import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '访问方式', path: '/category/access-methods' },
      { name: '功能介绍', path: '/category/features' },
      { name: '使用教程', path: '/category/tutorials' },
      { name: '常见问题', path: '/category/faq' },
      { name: '最新动态', path: '/category/latest-news' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about' },
      { name: '用户口碑', path: '/about' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { name: '官方入口指南', path: '/article/free91-official-entrance-guide' },
      { name: '手机端访问教程', path: '/article/free91-mobile-access-tutorial' },
      { name: '新手入门教程', path: '/article/free91-beginner-tutorial' },
      { name: '进阶使用技巧', path: '/article/free91-advanced-tips' },
      { name: '常见问题汇总', path: '/article/free91-faq-collection' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-background-50 hover:text-primary-300 transition-colors whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                91
              </span>
              免费91网页
            </Link>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              免费91网页官方入口与完整使用指南，为用户提供访问方式、功能介绍、使用技巧及常见问题解答，帮助用户快速安全地使用平台全部核心功能。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 免费91网页 | 本站为非官方导航指南网站，仅供信息参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-300 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}